import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#065f46", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#d1fae5", border: "1px solid #6ee7b7", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#064e3b", lineHeight: 1.6 },
}));

const DEFAULT = {
  msgCpf: "Por favor, informe seu *CPF* (somente números) para continuar:",
  msgCpfInvalido: "CPF inválido. Por favor, envie apenas os 11 dígitos:",
  msgMenu: "Olá! O que você deseja consultar?\n\n*1* - 📅 Agendamentos\n*2* - 💪 Treinos\n*3* - 💰 Faturas",
  msgOpcaoInvalida: "Opção inválida. Digite *1*, *2* ou *3*:",
};

const FlowBuilderScMenuPacienteModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ ...DEFAULT, ...data.data.data });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    const label = "Sys Clínica — Menu Paciente";
    if (open === "edit") {
      onUpdate(data.id, { data: { label, data: cfg } });
    } else {
      onSave({ label, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  const field = (key, label, rows = 1, helper = "") => (
    <TextField
      label={label}
      value={cfg[key]}
      onChange={(e) => setCfg({ ...cfg, [key]: e.target.value })}
      fullWidth margin="dense" variant="outlined"
      multiline={rows > 1} minRows={rows}
      helperText={helper}
    />
  );

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>Sys Clínica — Menu Paciente</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Verifica se o contato tem CPF cadastrado. Se não tiver, solicita e salva automaticamente.<br />
            Após confirmar o CPF, envia um menu com <strong>Agendamentos</strong>, <strong>Treinos</strong> e <strong>Faturas</strong>.
          </Typography>
        </Box>

        {field("msgCpf", "Mensagem para solicitar CPF", 2)}
        {field("msgCpfInvalido", "Mensagem CPF inválido", 2)}
        {field("msgMenu", "Mensagem do menu (use *1*, *2*, *3*)", 4)}
        {field("msgOpcaoInvalida", "Mensagem opção inválida", 2)}

        <Box style={{ marginTop: 16, padding: 12, background: "#f0fdf4", borderRadius: 8, border: "1px solid #6ee7b7" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#064e3b", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#065f46" }}>
            🔵 <strong>agendamentos</strong> — paciente escolheu opção 1<br />
            🟣 <strong>treinos</strong> — paciente escolheu opção 2<br />
            🔴 <strong>faturas</strong> — paciente escolheu opção 3<br />
            ❌ <strong>erro</strong> — falha de API ou integração inativa
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderScMenuPacienteModal;
